import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import Button from '@mui/material/Button'

# Build toasts by hand and display them here
export default class GlobalToast extends React.Component
  constructor: (props) ->
    super props
    @state = {toasts: []}

  componentDidMount: ()->
    # set up the listener for the toasts
    window.app.emitter.addListener 'global toast', (message, autohide=null) =>
      # add the toast
      @setState  {toasts: [{text: message, action: 'OK'}]}

      # set to automatically dismiss, if parameter provided
      clearTimeout @dismissTimeout
      if !autohide? || autohide
        @dismissTimeout = setTimeout () =>
          console.log "Clearing latest toast..."
          @setState { toasts: [] }
        , @props.dismissTime

    # call the ready function
    setTimeout ->
      window.app.ready()
    , 50

  componentWillUnmount: () ->
    clearTimeout @dismissTimeout

  dismissToast: (event, reason) =>
    # MUI Snackbar onClose fires with reason 'clickaway' on any outside click —
    # don't dismiss the toast for that (only timeout / escape / the OK button,
    # which calls this with no reason).
    return if reason == 'clickaway'
    @setState { toasts: []}

  render: ->
    { toasts } = @state
    toast = toasts[0]

    <Snackbar
      id="global-snackbar"
      open={!!toast}
      onClose={@dismissToast}
      message={toast?.text || ''}
      autoHideDuration={@props.dismissTime}
      action={
        <Button color="secondary" size="small" onClick={@dismissToast}>
          OK
        </Button>
      }
    />
GlobalToast.defaultProps =
  dismissTime: 5000

